import { Link } from 'react-router-dom';
import { ReactComponent as FooterLogo } from '../../Assets/logo2.svg';
import useTranslate from '../../Hooks/useTranslate';
import Text from '../../Style-guide/Text';
import FooterWrapper from './style/footerWrapper';

const Footer = () => {
  const tr = useTranslate();

  return (
    <FooterWrapper>
      <FooterLogo className='footer-logo' />
      <div className='footer-links-container'>
        <Link to='/contact-us' className='footer-link'>
          <Text>{tr('contact_us')}</Text>
        </Link>
        <Link to='/terms-conditions' className='footer-link'>
          <Text>{tr('terms_and_conditions')}</Text>
        </Link>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
